import { createContext, useCallback, useContext, useMemo, useState } from "react";

import { HiringInstantPayConfetti } from "./HiringInstantPayConfetti";

interface ConfettiContextValue {
  triggerConfetti: () => void;
}

const ConfettiContext = createContext<ConfettiContextValue | undefined>(undefined);

export function useConfetti(): ConfettiContextValue {
  const context = useContext(ConfettiContext);

  if (!context) {
    throw new Error("useConfetti must be used within ConfettiProvider");
  }

  return context;
}

interface ConfettiProviderProps {
  children: React.ReactNode;
}

export function HiringInstantPayConfettiProvider(props: ConfettiProviderProps) {
  const { children } = props;
  const [showConfetti, setShowConfetti] = useState(false);

  const triggerConfetti = useCallback(() => {
    setShowConfetti(true);
  }, []);

  const handleConfettiComplete = useCallback(() => {
    setShowConfetti(false);
  }, []);

  const contextValue = useMemo(() => ({ triggerConfetti }), [triggerConfetti]);

  return (
    <ConfettiContext.Provider value={contextValue}>
      {children}
      <HiringInstantPayConfetti isActive={showConfetti} onComplete={handleConfettiComplete} />
    </ConfettiContext.Provider>
  );
}
